const message =
  "Enter your <strong>SteamID</strong> to continue.<br/> Do you want me to guess your taste in games?";

export default message;
